import { cn } from '@/shared/utils/cn';

type FormShellProps = {
  title?: string;
  description?: string;
  children: React.ReactNode;
  className?: string;
  /** Elimina el borde, sombra y fondo de tarjeta para usar el formulario sin contenedor visual. */
  naked?: boolean;
};

export function FormShell({
  title,
  description,
  children,
  className,
  naked = false,
}: FormShellProps) {
  return (
    <div
      className={cn(
        '@container w-full text-left',
        !naked &&
          'rounded-adipa-lg border-adipa-border bg-adipa-surface shadow-adipa-card border p-5 sm:p-6',
        className,
      )}
    >
      {(title || description) && (
        <div className="mb-6">
          {title && <h2 className="text-adipa-text-primary text-xl font-semibold">{title}</h2>}
          {description && <p className="text-adipa-text-secondary mt-1 text-sm">{description}</p>}
        </div>
      )}
      {children}
    </div>
  );
}
